import { useTranslate } from '@refinedev/core';
import { PresencePill } from '@/components/common/PresencePill';

interface PublisherContractTagProps {
  hasActiveContract?: boolean | null;
}

/** `✓ Umowa` when the publisher has a signed contract, muted `– Umowa` otherwise. */
export const PublisherContractTag = ({
  hasActiveContract,
}: PublisherContractTagProps) => {
  const t = useTranslate();
  return (
    <PresencePill
      present={!!hasActiveContract}
      label={t('content_catalog.publishers.fields.has_active_contract')}
      tooltip={t(
        `content_catalog.publishers.contract.${hasActiveContract ? 'active' : 'none'}`
      )}
    />
  );
};
